/* eslint-disable no-unused-vars */
import { useEffect, useState } from 'react';
import ReactDOM from 'react-dom/client';

import { BrowserRouter, Routes, Route } from 'react-router-dom';
import DoctorProfileForm from './doctor/ConsultantProfileForm.js';
import api, { API_URL, AuthProvider } from './util/api.js';
import Register from './pages/register.js';
/*  import RoleSelection from './pages/select_role.js';
import ConsultantProfileForm from './doctor/ConsultantProfileForm.js';
import DoctorDashboard from './doctor/DoctorDashboard.js'; */
/* import Footer from './footer.js';  */
/* import Header from './header.js'; */

import DoctorsDashboard from './doctor/dashboard.js';
import Home from './home.js';
import Login from './pages/login.js';
import DoctorChatBox from './chat/chatBox.js';
import DoctorChat from './doctor/DoctorChat.js';
import SelectRolePage from './pages/selectRole.js';
import DoctorProfile from './components/doctorprofile.js';
import ScrollToTop from './components/ScrollTop.js';
import AppointmentInteractionPage from './patients/appointment_details.js';

import PaymentPage from './components/payment_options.js';
import PatientForm from './patients/patientForm.js';
import PatientDashboard from './patients/dashboard.js';
import Doctors from './doctors.js';
import DocOngoingAppoint from './doctor/ongoingappoinments.js';
import DocCompletedAppoint from './doctor/completedappointments.js';
import DocAppointments from './doctor/doctorappointment.js';
import Transactions from './transactions.js';
import PatientOngoingAppointments from './patients/appointments.js';
import PatientAppointments from './patients/appointments.js';
import ConsultationCompletion from './doctor/consultation_completion.js';
import ConsultationReadOnly from './doctor/consultation_read_only.js';
import ConsultationHistory from './patients/consultation_history.js';
import BitcoinDepositPage from './components/crypto_payment/BitcoinPayment.js';
import AdminChatLauncher from './pages/chat/adminchatbox.js';
import ProvideEmail from './forgot/forgot.js';
import ChangePassword from './forgot/change_password.js';
import NotificationPage from './pages/Notification.js';
import TermsAndConditions from './pages/termsconditions.js';
import AboutUs from './pages/aboutus.js';
import useLogoutSync from './components/checklogout.js';
import useUserPresence from './components/useUserPresence.js';
import AdminLogin from './pages/adminLogin.js';
import VideoCallPage from './chat/VideoCallPage.js';
import PaymentDetails from './PaymentDetails.js';
import WithdrawHistory from './withdraw_history.blade.js';
import { HelmetProvider } from "react-helmet-async";
import NotFound from './pages/nofound.js';
import GeneralTermsConditions from './pages/generalterms.js';






function App() {


  const [deferredPrompt, setDeferredPrompt] = useState(null);
  const [canInstall, setCanInstall] = useState(false);
  const [showIosInstallGuide, setShowIosInstallGuide] = useState(false);
  const [showInstallModal, setShowInstallModal] = useState(false);


  useEffect(() => {

      
    if ('serviceWorker' in navigator) {


      navigator.serviceWorker
        .register("/sw.js")
        .then((registration) => {
          console.log("SW registered");

          return navigator.serviceWorker.ready;
        })
        .then(() => {
          console.log("SW Ready");
        });


      /*   navigator.serviceWorker.register('/sw.js')
          .then(() => console.log('SW registered'));
   */

    }
  }, []);


  useEffect(() => {
    const handler = (e) => {


      e.preventDefault();
      setDeferredPrompt(e);
      setCanInstall(true);
    };

    window.addEventListener("beforeinstallprompt", handler);

    return () => window.removeEventListener("beforeinstallprompt", handler);
  }, []);


  // Detect iOS Safari and show guide
  useEffect(() => {
    const isIos = () =>
      /iphone|ipad|ipod/.test(window.navigator.userAgent.toLowerCase());
    const isInStandaloneMode = () =>
      'standalone' in window.navigator && window.navigator.standalone;

    if (isIos() && !isInStandaloneMode()) {
      setShowIosInstallGuide(true);
    }
  }, []);


  const handleInstall = async () => {
    if (!deferredPrompt) return;
    deferredPrompt.prompt();

    const { outcome } = await deferredPrompt.userChoice;
    if (outcome === "accepted") {
      console.log("User accepted the install");
    } else {
      console.log("Install", "User dismissed the install", "info");
    }

    setDeferredPrompt(null);
    setCanInstall(false);
  };


  useLogoutSync();
  useUserPresence();
  const path = window.location.pathname;
  const hideChat = path === '/login' || path === '/register';

  async function checkversion() {

    const version = await api.get(API_URL + `/version`);
    const getv = version.data;

    const savedVersion = localStorage.getItem('app_version1');
    if (savedVersion !== getv.version) {

      localStorage.setItem('app_version1', getv.version);
      window.location.reload(true); // hard refresh

    } else {
      localStorage.setItem('app_version1', getv.version);

    }


  }






  useEffect(() => {
    checkversion();

  }, []);



  return (
    <>
      <HelmetProvider>

        <style>{`
              @keyframes fadeInUp {
                from { opacity:0; transform: translateY(20px); }
                to { opacity:1; transform: translateY(0); }
              }

              @keyframes floatBtn {
                0% { transform: translateY(0); }
                50% { transform: translateY(-6px); }
                100% { transform: translateY(0); }
              }

              .installBtn {
                position: fixed;
                bottom: 24px;
                left: 24px;
                background: linear-gradient(135deg, #0A3D62, #3C91E6);
                color: #fff;
                padding: 14px 18px;
                border-radius: 50px;
                font-weight: 600;
                cursor: pointer;
                box-shadow: 0 12px 30px rgba(0,0,0,0.2);
                z-index: 9999;
                animation: floatBtn 3s infinite ease-in-out;
                transition: 0.3s;
              }

              .installBtn:hover {
                transform: scale(1.05);
              }

              .installModal {
                position: fixed;
                top: 0;
                left: 0;
                width: 100%;
                height: 100%;
                background: rgba(0,0,0,0.5);
                display: flex;
                align-items: center;
                justify-content: center;
                z-index: 10000;
              }

              .installCard {
                background: #fff;
                padding: 28px;
                border-radius: 16px;
                max-width: 400px;
                width: 90%;
                animation: fadeInUp 0.4s ease;
                text-align: center;
              }

              .installCard h3 {
                margin-bottom: 12px;
              }

              .installCard p {
                font-size: 14px;
                margin-bottom: 20px;
                color: #555;
              }

              .installActions {
                display: flex;
                gap: 10px;
                justify-content: center;
              }

              .btnPrimary {
                background: #0A3D62;
                color: #fff;
                padding: 10px 16px;
                border-radius: 8px;
                cursor: pointer;
                border: none;
              }

              .btnSecondary {
                background: #eee;
                padding: 10px 16px;
                border-radius: 8px;
                cursor: pointer;
                border: none;
              }

              @media(max-width: 600px){
                .installBtn {
                  bottom: 16px;
                  left: 16px;
                  padding: 12px 16px;
                  font-size: 14px;
                }
              }
            `}</style>

        <BrowserRouter>

          <AuthProvider>

            {/*   <Header/> */}
            <ScrollToTop />


            <Routes>
              <Route path='/' element={<Home />} />



              <Route path='/register' element={<Register />} />
              <Route path='/login' element={<Login />} />
              <Route path='/admin_login' element={<AdminLogin />} />



              {/* patient Routes  */}

              <Route path="/client-dashboard" element={<PatientDashboard />} />
              <Route path="/client-reg" element={<PatientForm />} />
              <Route path="/client-ongoing-cases" element={<PatientAppointments title='Ongoing Cases' link='/client-ongoing-cases' />} />
              <Route path="/client-completed-cases" element={<PatientAppointments title='Completed Cases' link='/client-completed-cases' />} />
              <Route path="/all-cases" element={<PatientAppointments title='All Cases' link='/all-cases' />} />
              {/* general auth routes  */}

              <Route path="/chatbox" element={<DoctorChat />} />
              <Route path="/video-call/:id" element={<VideoCallPage />} />

              <Route path="/select-role" element={<SelectRolePage />} />
              <Route path="/lawyer-profile/:id" element={<DoctorProfile />} />
              <Route path="/appointment/:id" element={<AppointmentInteractionPage />} />


              <Route path="/payment_options/:appointment_id" element={<PaymentPage />} />

              <Route path="crypto_payment/:currency/:appointment_id" element={<BitcoinDepositPage />} />
              <Route path="/payment_details" element={<PaymentDetails />} />


              <Route path="/lawyers" element={<Doctors />} />

              {/* doctors  routes */}
              <Route path="/lawyer-profile-reg" element={<DoctorProfileForm />} />
              <Route path="/lawyer-dashboard" element={<DoctorsDashboard />} />
              <Route path="/lawyer-active-cases" element={<DocOngoingAppoint />} />
              <Route path="/lawyer-closed-cases" element={<DocCompletedAppoint />} />
              <Route path="/doctor-doctor-appointments" element={<DocAppointments />} />


              {/* both patient and doctor routes  */}

              <Route path="/transactions" element={<Transactions />} />
              <Route path="/withdraw-history" element={<WithdrawHistory />} />

              <Route path="/complete_consultation/:appointment_id" element={<ConsultationCompletion />} />
              <Route path="/consultation/:id" element={<ConsultationReadOnly />} />
              <Route path="/case-history/:id" element={<ConsultationHistory />} />
              <Route path="/notifications" element={<NotificationPage />} />

              <Route path="/forgot-password" element={<ProvideEmail />} />
              <Route path="/change_password" element={<ChangePassword />} />
              <Route path="/appointment-terms-and-conditions" element={<TermsAndConditions />} />
              <Route path="/terms-and-conditions" element={<GeneralTermsConditions />} />
              <Route path="/about-us" element={<AboutUs />} />

              <Route path="*" element={<NotFound />} />









            </Routes>




            {/*  <Footer/> */}
            {/* {!hideChat && (
              <div style={{ backgroundColor: "red", position: "relative" }}>

                <AdminChatLauncher />

              </div>

            )}
 */}


            {/* INSTALL BUTTON */}
            {(canInstall || showIosInstallGuide) && (
              <div
                className="installBtn"
                onClick={() => setShowInstallModal(true)}
              >
                📲 Install App
              </div>
            )}






            {/* INSTALL MODAL */}
            {showInstallModal && (
              <div className="installModal">
                <div className="installCard">
                  <h4>{canInstall ? "Install This App" : "App Installed Successfully"}</h4>

                  {canInstall && (
                    <p>
                      Add this app to your device for faster access and a better experience.
                    </p>
                  )}

                  {showIosInstallGuide && (
                    <p>
                      On iPhone/iPad: Tap <b>Share</b> → then <b>"Add to Home Screen"</b>.
                    </p>
                  )}

                  <div className="installActions">
                    {canInstall && (
                      <button className="btnPrimary" onClick={handleInstall}>
                        Install Now
                      </button>
                    )}

                    <button
                      style={{ color: "red" }}
                      className="btnSecondary"
                      onClick={() => setShowInstallModal(false)}
                    >
                      Close
                    </button>
                  </div>
                </div>
              </div>
            )}


          </AuthProvider>
        </BrowserRouter>

      </HelmetProvider>

    </>
  )
}

export default App
